<template>
  <v-dialog
    id="qmkey-form-modal-dialog" 
    v-model="showModalDialog"
    persistent
    refs="modalDialog"
    @keydown.esc="close"
    content-class="qmkey-modal-dialog"
    
  >
    <v-card

      :loading="loading"
    >
      <v-card-title class="modal-card-title">
          <span  class="qmkey-modal-h1 pb-0"> {{ title }}</span>
          <v-spacer></v-spacer>
          <v-btn class="qmkey-modal-dialog-close" text plain right small :ripple="false" @click="close">
              <v-icon :ripple="false" small>mdi-close</v-icon>
          </v-btn>  
      </v-card-title>
      <v-divider class="modal-card-title-divider mt-0 pt-0"></v-divider>
      <v-card-subtitle> </v-card-subtitle>
      <v-card-text>
        <DynamicForm
            :fields="fields_to_collect"
            ref="dynamicForm"
            @ready="isReady => valid = isReady"
        />
        <div class="text-block">
              <pre> {{ message }} </pre>
        </div>
      </v-card-text>
      <v-card-actions class="qmkey-modal-dialog-card-actions">
        <v-spacer></v-spacer>        
        <v-btn 
          class="qmkey-modal-dialog-button-secundary"
          @click="local_clear"
          color="#FFFFFF"
        > 
          Clear
        </v-btn>
        <v-btn
          class="qmkey-modal-dialog-button-submit"
          text
          @click.prevent="perform_action"
          :disabled="!valid"
        >
          {{submit_button_label}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import DynamicForm from '@/components/DynamicForm'

export default {
  name: 'ModalDialogForm',
  components: {
    DynamicForm,
  },
  props: {
    title: String,
    showModalDialog: Boolean,
    fields_to_collect: Array, 
    submit_button_text: String,
    message: String,
  },
  data() {
    return {
      valid: null,
      disable: false,
      alert: false,
      err: '',
      loading: false,
    }
  },
  computed: {    
        
    submit_button_label() {
      // TODO:lang
      return this.submit_button_text
    },
    ...mapState([
      'sitePath',
      'current_business_process',
      'current_business_process_name',      
    ]),
  },
  
  methods: {
    clear() {
      console.log("dialog clear")
      this.alert = false
      // this.$refs.dynamicForm.clear();
    },
    close() {
      console.log("dialog close")
      this.local_clear()
      this.valid = true
      this.disable = false
      this.$emit("close-dialog", '')
    },
    perform_action: function(evt) {
      evt.preventDefault()
      console.log("dialog submit", this.$refs.dynamicForm.validate())
      var creation_form = this.$refs.dynamicForm.get_data();
      console.log("dialog submit II", this.$refs.dynamicForm.form)
      this.$emit("submit", creation_form)
      
    },
    local_clear() {
      console.log("dialog local_clear")
      this.alert = false
      try {
        // FIXME:
        this.$refs.dynamicForm.clear();
      }catch (error) {
        console.log("Error", error)
      }
    },

  },
  watch: {
    enable_button: function() {
      if (this.$refs.dynamicForm){
        console.log("this.$refs.dynamicForm.form", this.$refs.dynamicForm.form)
        this.valid = this.$refs.dynamicForm.form
      }
      this.valid = false
    }
   },
}
</script>

<style lang="scss">
@import '@/sass/modalform.scss';
</style>

